import React from "react"
import { SvgCheckCircle } from "../icons"
import { RegisterFormProvider } from "../auth/register-form/context"
import FreeConsultGuestCreation from "./FreeConsultGuestCreation"

interface Props {
  service: any
  coachPublicProfileData: any
  canBookFreeConsultationAsGuest: any
  getProfileServiceList: any
  coachColor: any
}

const FreeConsultation: React.FC<Props> = ({
  service,
  coachPublicProfileData,
  canBookFreeConsultationAsGuest,
  coachColor,
  getProfileServiceList,
}) => {
  return (
    <>
      {service?.service_details?.details?.description1 && (
        <div className="mb-8">
          {service?.service_details?.details?.description1}
        </div>
      )}
      {service?.service_details?.details?.features?.feature1 && (
        <div className="mb-8 mr-auto flex flex-col gap-4 text-base">
          <div className="flex items-center gap-[12px]">
            <SvgCheckCircle
              fill={`${coachPublicProfileData?.profile_information?.profileColor}`}
            />
            {service?.service_details?.details.features.feature1}
          </div>
          {service?.service_details?.details?.features?.feature2 && (
            <div className="flex items-center gap-[12px]">
              <SvgCheckCircle
                fill={`${coachPublicProfileData?.profile_information?.profileColor}`}
              />
              {service?.service_details?.details.features.feature2}
            </div>
          )}
          {service?.service_details?.details?.features?.feature3 && (
            <div className="flex items-center gap-[12px]">
              <SvgCheckCircle
                fill={`${coachPublicProfileData?.profile_information?.profileColor}`}
              />
              {service?.service_details?.details.features.feature3}
            </div>
          )}
        </div>
      )}
      <div className="bg-grayMist mb-4 h-[1px] w-full px-[20px]"></div>
      {canBookFreeConsultationAsGuest && (
        <>
          <RegisterFormProvider
            defaultEmail=""
            defaultAccountType={null}
            defaultFirstName=""
            defaultLastName=""
            defaultPassword=""
            defaultPhone=""
            onSuccess={() => true}
          >
            <FreeConsultGuestCreation
              coachPublicProfileData={coachPublicProfileData}
              service={service}
              getProfileServiceList={getProfileServiceList}
              coachColor={coachColor}
            />
          </RegisterFormProvider>
        </>
      )}
    </>
  )
}

export default FreeConsultation
